<template>
  <div class="special-price">
    <div class="section-header" v-if="showTitle">
      <span class="icon">👍</span>
      <h3>特价专区</h3>
      <router-link
        :to="{
          path: '/category-detail',
          query: { navCode: 1061 },
        }"
        class="more-link"
      >
        more >
      </router-link>
    </div>
    <div class="products-grid" :style="gridStyle">
      <div
        v-for="product in productList"
        :key="product.id"
        class="product-item"
        @click="handleProductClick(product.url)"
      >
        <img :src="product.imageUrl" :alt="product.name" />
        <div class="product-info">
          <p class="name" v-if="showProductName">{{ product.name }}</p>
          <p class="price">
            <small>¥</small>
            <span class="price-value">{{ formatPrice(product.price) }}</span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted, computed } from "vue";
import { getSpecialPriceProducts } from "@/api/advertisement";

export default {
  name: "SpecialPrice",

  props: {
    referenceCode: {
      type: String,
      required: true,
    },
    referenceKind: {
      type: String,
      default: "specialactivity",
    },
    pageSize: {
      type: Number,
      default: 10,
    },
    productInRow: {
      type: Number,
      default: 2,
    },
    showTitle: {
      type: Boolean,
      default: true,
    },
    showProductName: {
      type: Boolean,
      default: true,
    },
    priceField: {
      type: String,
      default: "SalePrice",
    },
  },

  setup(props) {
    const productList = ref([]);

    const gridStyle = computed(() => ({
      "grid-template-columns": `repeat(${props.productInRow}, 1fr)`,
    }));

    const formatPrice = (price) => {
      if (!price) return "0.00";
      return Number(price).toFixed(2);
    };

    const handleProductClick = (url) => {
      if (url) {
        window.location.href = url;
      }
    };

    const fetchSpecialProducts = async () => {
      try {
        const res = await getSpecialPriceProducts({
          referenceCode: props.referenceCode,
          referenceKind: props.referenceKind,
          pageSize: props.pageSize,
          productInRow: props.productInRow,
          showProductName: props.showProductName,
          priceField: props.priceField,
        });

        if (res?.Data) {
          productList.value = res.Data;
        }
      } catch (error) {
        console.error("获取特价商品失败:", error);
      }
    };

    onMounted(() => {
      fetchSpecialProducts();
    });

    return {
      productList,
      handleProductClick,
      gridStyle,
      formatPrice,
    };
  },
};
</script>

<style scoped>
.special-price {
  flex: 1;
  padding: 10px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.section-header {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  padding: 0 8px;
}

.section-header h3 {
  margin: 0 10px;
  font-size: 16px;
}

.section-header .icon {
  font-size: 18px;
}

.section-header .more {
  margin-left: auto;
  color: #999;
  font-size: 14px;
}

.products-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
  padding: 0 8px;
}

.product-item {
  text-align: center;
  cursor: pointer;
}

.product-item img {
  width: 100%;
  height: auto;
  border-radius: 4px;
  aspect-ratio: 1;
  object-fit: cover;
}

.price {
  color: #ff4444;
  font-weight: bold;
  margin: 5px 0;
}

.price small {
  font-size: 12px;
  margin-right: 2px;
}
</style>
